<template>
  <div>
    <v-layout row wrap justify-center>
      <ui-title-red textTitle="Presupuesto mensual: Ingresos por salario"></ui-title-red>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Presupuesto mensual: Ingresos por salario'" videoEmbed="ADMINISTRACIONDINERO24IngresosXSalario (55).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 mt-4>
        <p>
          Lo primero que determinará serán sus ingresos por concepto de salario mensual. <br> Debe completar el siguiente cuadro con sus ingresos únicamente en los campos donde aplique. <br> Encontrará cuatro columnas: <br>
        </p>
        <ui-list bullet="bullet-dav" :lista="lista"></ui-list>
        <p>
          Importante: no incluya puntos ni comas.
        </p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <ui-calculadora
      :formulario="ingresoSalario"
      :nombresCols="nombres"
      :resultadoDiferencia="resultadoDiferencia"
      :resultadoTotal="resultadoTotal"
      ></ui-calculadora>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      lista: [
        "La primera especifica el <strong>tipo de ingreso.</strong>",
        "En la segunda <strong>debe digitar el valor real que recibe durante el mes.</strong>",
        "La tercera columna es opcional y se refiere al dinero que usted espera que ingrese para un mes determinado.",
        "La última columna calcula la diferencia automáticamente, en caso de haber diligenciado los valores planeados. "
      ],
      nombres: [
        "<span class='font-red'>Ingreso por salario mensual</span>",
        "<span class='font-red'>Valor real,</span><br> (Lo efectivamente recibido durante el mes)",
        "<span class='font-red'>Valor planeado,</span><br> (El esperado inicialmente en el presupuesto mensual)",
        "<span class='font-red'>Diferencia mensual</span>"
      ]
    };
  },
  computed: {
    ingresoSalario() {
      return this.$store.state.ingresoSalario;
    },
    resultadoDiferencia() {
      return this.$store.getters.ingresoSalarioDiferencia;
    },
    resultadoTotal() {
      return this.$store.getters.ingresoSalarioTotal;
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-24.vue?22a79c51